import { FC, useCallback, useMemo, useState } from "react";
import { DateSchemaItem } from "@data-root/types";
import { View, useAppContext } from "@data-root/react";
import { Button, Input, Modal, Calendar, Skeleton } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { SchemaItemProps, useField } from "@data-root/react";
import { inputGuard } from "../../hocs/guard";
import dayjs, { Dayjs } from "dayjs";
import { Typography } from "antd";
import { DEFAULT_DATE_FORMAT } from "@data-root/core";
import { Remarks } from "../remarks";

const { Title } = Typography;

export const DateInput: FC<SchemaItemProps<DateSchemaItem>> = inputGuard(
  ({ item }) => {
    const { configuration } = useAppContext();

    const {
      loaded,
      value,
      displayValue,
      setValue,
      displayName,
      placeholder,
      editable,
      show,
      remarks,
    } = useField(item);

    const [visible, setVisible] = useState(false);

    const _value = useMemo(
      () => (value ? dayjs(value as string) : undefined),
      [value]
    );

    const _setValue = useCallback(
      (value: Dayjs) => {
        // setValue(value, value);
        setValue(
          // NOTE: PocketBase requires time information (not just date),
          // since the available type is `DateTime` and not just `Date`.
          value.toISOString(),
          value.format(configuration?.dateFormat ?? DEFAULT_DATE_FORMAT)
        );
      },
      [configuration?.dateFormat, setValue]
    );

    const onConfirm = useCallback(() => {
      setVisible(false);
    }, []);

    const onDismiss = useCallback(() => {
      setVisible(false);
    }, [setVisible]);

    const handleOnOpenDialog = useCallback(() => {
      setVisible(true);
    }, []);

    if (!show) return null;

    return (
      <>
        <Modal centered open={visible} onOk={onConfirm} onCancel={onDismiss}>
          <Calendar fullscreen={false} value={_value as any} onSelect={_setValue} />
        </Modal>

        <View
          // ref={ref}
          style={{ width: "100%" }}
        >
          <Title level={5}>{displayName}</Title>

          {!loaded ? (
            <Skeleton.Input block active />
          ) : (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <Input
                readOnly
                maxLength={10}
                placeholder={placeholder}
                value={displayValue}
              />

              {editable && (
                <Button
                  type="primary"
                  icon={<CalendarOutlined />}
                  onClick={handleOnOpenDialog}
                />
              )}
            </View>
          )}

          <Remarks texts={remarks} />
        </View>
      </>
    );
  }
);
